import { render, staticRenderFns } from "./PollView.vue?vue&type=template&id=62ff71f6&scoped=true"
import script from "./PollView.vue?vue&type=script&lang=js"
export * from "./PollView.vue?vue&type=script&lang=js"
import style0 from "./PollView.vue?vue&type=style&index=0&id=62ff71f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff71f6",
  null
  
)

export default component.exports